export const calendar = {
  title: "Calendario",
  subtitle: "Gestisci le prenotazioni delle tue strutture",
  createBooking: "Crea prenotazione",
  propertyLabel: "Alloggio",
  searchPlaceholder: "Cerca alloggio",
  filterByProperty: "Filtra strutture",
  clearFilters: "Cancella filtri",
  loadingMore: "Caricamento di altre date…",

  payment: {
    "pending":  "Pagamento in sospeso",
    "paid":     "Pagato",
    "rejected": "Pagamento rifiutato",
    "refunded": "Rimborsato",
    "partial":  "Pagamento parziale"
  },

  tooltips: {
    noChannels: "Non connesso ad alcun canale",
    connectedTo: "Connesso a: {channels}",
    manual: "WA Checkin (manuale)",
    other: "Altro canale",
    configPrices: "Configura prezzi",
  },

  errors: {
    loadCalendar: "Errore durante il caricamento dei dati del calendario",
    updateViewAfterCancel: "Errore durante l'aggiornamento della vista dopo l'annullamento",
    closeDates: "Errore durante la chiusura delle date",
    deleteClosedDates: "Errore durante l'eliminazione delle date chiuse",
    updateClosedDates: "Errore durante l'aggiornamento delle date chiuse",
  },

  filters: {
    showPrices: "Mostra prezzi",
    today: "Oggi",
    multi: "Multiplo",
    monthly: "Mensile",
    prevMonthAria: "Mese precedente",
    nextMonthAria: "Mese successivo",
  },

  actions: {
    title: "Seleziona un'azione",
    question: "Cosa vuoi fare con le date selezionate?",
    createBooking: "Crea prenotazione",
    blockDates: "Chiudi data",
    editNightPrice: "Modifica prezzo a notte",
    editMinStay: "Soggiorno minimo",
    editMinStayHint: "Imposta il numero minimo di notti per data",
  },
  minStayModal: {
    description:
      "Imposta il soggiorno minimo per l'intervallo di date selezionato. Questo non influirà sui prezzi esistenti.",
    success: "Soggiorno minimo aggiornato con successo",
    hint: "Numero minimo di notti che l'ospite deve prenotare.",
    errors: {
      minOne: "Il soggiorno minimo deve essere di almeno 1 notte.",
    },
  },

  fields: {
    startDate: "Data di inizio",
    endDate: "Data di fine",
  },

  buttons: {
    delete: "Elimina",
    cancel: "Annulla",
    save: "Salva",
    close: "Chiudi",
    saveChanges: "Salva modifiche",
    closeDates: "Chiudi date",
  },

  closeModal: {
    headerCreate: "CHIUDI DATE",
    headerEdit: "MODIFICA DATE CHIUSE",
  },

  priceModal: {
    description:
      "Si tratta di una modifica manuale alla tariffa selezionata. Tutto ciò che modifichi qui influirà solo su questo alloggio e su questo intervallo di date.",
    periodLabel: "Periodo di date",
    startPlaceholder: "Data di inizio",
    endPlaceholder: "Data di fine",
    pricePerNight: "Prezzo a notte",
    minStay: "Soggiorno minimo",
    minNightsPlaceholder: "Notti minime",
    pricePlaceholder: "Prezzo per l'intervallo selezionato",
    success: "Prezzi aggiornati con successo",
    errors: {
      invalidRange: "Devi selezionare un intervallo di date valido",
      startAfterEnd: "La data di inizio non può essere successiva alla data di fine",
      minStay:
        "Il soggiorno minimo è di {min} notti, ma l'intervallo selezionato ha {nights} notti",
      missingSelection: "Non è stata selezionata alcuna struttura o intervallo di date",
      request: "Errore nella richiesta: {msg}",
      update: "Errore durante l'aggiornamento dei prezzi: {msg}",
    },
  },

  details: {
    header: "Dettagli della prenotazione",
    title: "Prenotazione",
    createdOn: "Creata il {date}",
    checkIn: "Check-in",
    checkOut: "Check-out",
    arrow: "→",
    statusLabel: "Stato",
    status: {
      booked: "Prenotato",
      blocked: "Bloccato",
    },
    night_one: "Notte",
    night_other: "Notti",
    actions: {
      view: "Visualizza prenotazione",
      changeRoom: "Cambia camera",
      cancel: "Annulla prenotazione",
    },
  },
};

export default calendar;
